import { BrokerData } from 'modules/Transfer/type';
import otherLogo from './images/other-logo.png';

export const OTHER_BROKER_ID = null;
// /support/api/v1/broker/config/list 接口中不会返回Other选项, 所以这里手动构造一个Other选项
export const otherBrokerOption: BrokerData = {
    broker: 'Other',
    id: OTHER_BROKER_ID,
    logo: otherLogo,
    company: '',
    dtc_number: '',
    license: 'Marsco',
    account_type: null
};

export { PARTIAL_ACATS_BASE_PATH } from '../../helper';
